export const parent = "pfgwkgu";
export const container = "c5irhqf";
export const slider = "s17rmkwg";
export const line = "lhtvzsa";

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");